import { ChangeDetectionStrategy, Component, HostBinding, input, Input } from '@angular/core';
import { ContactsData } from '@bazis/form/models/form-element.types';
import { PhonePipe } from '@bazis/shared/pipes/phone.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'bazis-card-contact',
    templateUrl: './card-contact.component.html',
    imports: [PhonePipe, TranslocoModule, CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardContactComponent {
    readonly contact = input<ContactsData>();

    @HostBinding('class') hostClassComponent = 'bazis-contact';
}
